import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LEADS_BENCHMARK_REDUCER_NAME } from '../constants';

export const YEARLY_OVERVIEW_PREFIX = 'leadsYearlyOverview';

export const LeadsBenchmarkYearlyOverviewActionTypes = {
  GET_YEARLY_OVERVIEW_DATA_SUCCESS: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} Yearly Overview] SUCCESS`,
  GET_YEARLY_OVERVIEW_DATA_ERROR: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} Yearly Overview] ERROR`,
  GET_YEARLY_OVERVIEW_DATA_LOADING: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} Yearly Overview] LOADING`,
  GET_YEARLY_OVERVIEW_DATA_CANCELLED: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} Yearly Overview] CANCELLED`,
};
